import { render, staticRenderFns } from "./ReportPostModal.vue?vue&type=template&id=5a4aed56"
import script from "./ReportPostModal.vue?vue&type=script&lang=js"
export * from "./ReportPostModal.vue?vue&type=script&lang=js"
import style0 from "./ReportPostModal.vue?vue&type=style&index=0&id=5a4aed56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default,Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
